import {CLOSE_LIGHTBOX, OPEN_LIGHTBOX} from "./types";

export const openLightbox = ( src ) => ({
    type: OPEN_LIGHTBOX,
    payload: { src }
})

export const closeLightbox = () => ({
    type: CLOSE_LIGHTBOX
})


// WEBPACK FOOTER //
// ./src/actions/lightbox.js